import { C_ACTION } from '../constans';

export const allOrders = (state = [], action) => {
  switch (action.type) {
    case C_ACTION.ADD_ALL_ORDERS: {
      return [...state, ...action.data];
    }
    case C_ACTION.DELETE_ALL_ORDERS: {
      return [];
    }
    default:
      return state;
  }
};
